export const YesOrNo = ['Yes', 'No'];
export const ValueType = {
  DateTimeType: 0,
  IntType: 1,
  FloatType: 2
};

export const vendorSearchInfo = vendors => {
  return {
    searchingColumns: [
      { name: 'vendorId', title: 'Vendor Id' },
      { name: 'companyName', title: 'Company Name' },
      { name: 'city', title: 'City' },
      { name: 'state', title: 'State' },
      { name: 'phone', title: 'Company Phone' },
      { name: 'email', title: 'Company Email' }
    ],
    searchingColumnExtensions: [
      { columnName: 'vendorId', width: 150 },
      { columnName: 'companyName', width: 250 },
      { name: 'city', width: 175 },
      { name: 'state', width: 175 },
      { columnName: 'phone', width: 175 },
      { columnName: 'email', width: 175 }
    ],
    searchingRows: vendors,
    idKey: 'vendorId',
    nameKey: 'companyName'
  };
};

const enrichVendorContacts = contacts =>
  (contacts ?? []).map(c => {
    const fullName = FormatPersonName(c);
    return {
      ...c,
      fullName,
      vendorContactName: fullName
    };
  });

export const vendorContactSearchInfo = vendorContacts => {
  const rows = enrichVendorContacts(vendorContacts);

  return {
    searchingColumns: [
      { name: 'contactId', title: 'Vendor Contact Id' },
      { name: 'vendorId', title: 'Vendor Id' },
      { name: 'fullName', title: 'Name' },
      { name: 'officePhone', title: 'Contact Phone' },
      { name: 'officeEmail', title: 'Contact Email' }
    ],
    searchingColumnExtensions: [
      { columnName: 'contactId', width: 150 },
      { columnName: 'vendorId', width: 150 },
      { columnName: 'fullName', width: 200 },
      { columnName: 'officePhone', width: 175 },
      { columnName: 'officeEmail', width: 175 }
    ],
    searchingRows: rows,
    idKey: 'contactId',
    nameKey: 'fullName'
  };
};

export const parseFormValue = (value, valueType) => {
  if (!value || value === '') return null;

  switch (valueType) {
    case ValueType.DateTimeType:
      return new Date(value).toISOString();
    case ValueType.IntType:
      return parseInt(value);
    case ValueType.FloatType:
      return parseFloat(value);
    default:
      console.log('Invalid Type');
      return null;
  }
};

export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

export const MapFamilyMembers = familyMembers =>
  Array.isArray(familyMembers)
    ? familyMembers.map(s => ({
        id: s.familyMemberId,
        title: `${s.firstName} ${s.lastName}`
      }))
    : [];

export const FormatPersonName = person => (person ? `${person.firstName} ${person.lastName}` : '');
